import React from 'react';
import { Hero } from '@/screens/Landing/Hero';
import { Apps } from '@/screens/Landing/Apps';
import { Features } from '@/screens/Landing/Features';
import { Screenshots } from '@/screens/Landing/Screenshots';
import { Plans } from '@/screens/Landing/Plans';
import { WhatsNew } from '@/screens/Landing/WhatsNew';
import { Faq } from '@/screens/Landing/Faq';
import { Contact } from '@/screens/Landing/Contact';
import { useSiteMeta } from '@/components/SiteMeta';

// One page, eight sections, in the order someone reads them: what it is, who each
// app is for, what it does, what it looks like, what it costs, what changed
// recently, the questions the permissions raise, and how to get in touch.
//
// Alternating tint (Apps / Screenshots / What's new) is what separates them
// visually; there are no dividers to keep in sync.
export const LandingScreen: React.FC = () => {
    useSiteMeta('web.meta.homeTitle', 'web.meta.homeDescription');

    return (
        <>
            <Hero />
            <Apps />
            <Features />
            <Screenshots />
            <Plans />
            <WhatsNew />
            <Faq />
            <Contact />
        </>
    );
};
